import { getPromotions } from 'pricing-pages-lib/api/PromotionApi';
import { PROMOTIONS } from './constants/RequestedDataTypes';
import makeFetchRequest from './helpers/makeFetchRequest';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
export const FetchPromotionsRequestTypes = createRequestTypes(PROMOTIONS);
export const FetchPromotionActions = createRequestActions(FetchPromotionsRequestTypes);
export const fetchPromotions = () => makeFetchRequest({
  requestActions: FetchPromotionActions,
  fetch: getPromotions
});